export enum WidgetWrapperState {
  DOCKED_DRAGGING,
  DOCKED_RESTING,
  UNDOCKED_DRAGGING,
  UNDOCKED_RESTING
}
